import {
  groundApi,
  type GroundResponse,
  type CategorizedResponse,
} from "@b2bportal/ground-api";
import axios from "axios";
import type { CarLocationSuggestion } from "./types";

export const fetchLocations = async (
  search: string,
  callback: (newOptions: CarLocationSuggestion[], search?: string) => void
): Promise<void> => {
  try {
    const res = await groundApi(axios).apiV1AutocompleteGroundPost({
      query: { l: search, LocationQuery: "Label" },
    });

    const options: CarLocationSuggestion[] =
      (res.data as unknown as GroundResponse).categories?.flatMap(
        (categoryRes: CategorizedResponse) =>
          categoryRes.results.map((s) => ({
            ...s,
            category: categoryRes.category,
            categoryLabel: categoryRes.label,
          }))
      ) ?? [];
    callback(options, search);
  } catch (e) {
    callback([], "");
  }
};
